import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Index from "./pages/Index";
import Products from "./pages/Products";
import Associates from "./pages/Associates";
import HumanResource from "./pages/HumanResource";
import ApplyJob from "./pages/ApplyJob";
import JoinUs from "./pages/JoinUs";
import About from "./pages/About";
import Founder from "./pages/Founder";
import NotFound from "./pages/NotFound";
import BetaProgram from "./pages/BetaProgram";
import PrivacyStatement from "./pages/PrivacyStatement";
import Prismedic from "./pages/Prismedic";
import Support from "./pages/Support";

const queryClient = new QueryClient();

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/prismedic" element={<Prismedic />} />
          <Route path="/associates" element={<Associates />} />
          <Route path="/human-resource" element={<HumanResource />} />
          <Route path="/apply-job" element={<ApplyJob />} />
          <Route path="/join-us" element={<JoinUs />} />
          <Route path="/beta-program" element={<BetaProgram />} />
          <Route path="/about" element={<About />} />
          <Route path="/founder" element={<Founder />} />
          <Route path="/privacy-statement" element={<PrivacyStatement />} />
          <Route path="/support" element={<Support />} />
          <Route path="/contact" element={<Support />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
